import PageMenu from "../navigation/menus/page-menu"

const Menu = (props) => <PageMenu links={props.content.link} />

export default Menu
